import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SubscriptionList } from '../../shared/models/asp.types';
import { GLOBAL_CONSTANT } from '../../shared/services/util.service';
import { DeliveryChecklistService } from '../../shared/services/delivery-checklist.service';

@Component({
  selector: 'app-vin-lookup',
  templateUrl: './vin-lookup.component.html',
  styleUrls: ['./vin-lookup.component.scss']
})
export class VinLookupComponent implements OnInit {

  private readonly subs: SubscriptionList = {};
  languageCd = 'en';
  digiChekId: string;
  subscriptions: SubscriptionList = {};
  vin: string;
  formChanged = true;
  isSubmitting = false;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly deliveryChecklistService: DeliveryChecklistService,
    ) { 
    this.subs.query = this.activatedRoute?.queryParams?.subscribe(params => {
      this.vin = params.vin;
    });
  }

  ngOnInit(): void {
    this.getChecklistsForVin();
  }

  public getChecklistsForVin() {
    this.isSubmitting = true;
    this.subscriptions.vinSubscription = this.deliveryChecklistService.getChecklistsForVin(this.vin)?.subscribe(data => {
      const result = data?.data;
      if (result?.vehicle?.vin === this.vin && result?.status != 'COMPLETED') {
        this.isSubmitting = false;
        this.navigateToCheckList(result)
      }else {
        this.navigateToCheckList();
      }
    }, error => {
        this.navigateToCheckList();
    });
  }

  public navigateToCheckList(result?) {
    this.router.navigate(['asp/deliveryChecklist/createChecklist'], {
      queryParams: result ? {
        id: result.digichkId,
        email: result.customer?.emailAddress,
      } : {
        vin: this.vin
      }
    });
  }

  formsNotEdited() {
    return this.formChanged;
  }
}
